import {
	getDomainSelcted,
	getSelectedConversation,
} from "../../Services/StorageService";
import { initiateConversation } from "./chats";

export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const BOT_WAIT_LOADER = "BOT_WAIT_LOADER";
export const SHOW_FAILED_LOADER = "SHOW_FAILED_LOADER";
export const HIDE_FAILED_LOADER = "HIDE_FAILED_LOADER";

export const showLoader = (title) => (dispatch, getState) => {
	let process = getState().loader.process;
	dispatch({ type: SHOW_LOADER, data: { process: [...process, title] } });
};

export const hideLoader = (title) => async (dispatch, getState) => {
	let process = getState().loader.process;
	if (process.length) {
		var index = process.indexOf(title);
		if (index !== -1) {
			process.splice(index, 1);
		}
		if (!process.length) {
			const selectedDomain = getDomainSelcted();
			if (selectedDomain && selectedDomain.landingBotId !== "") {
				const selectedConversation = await getSelectedConversation();
				if(selectedConversation)
					initiateConversation(selectedConversation);
			}
		}
		dispatch({ type: HIDE_LOADER, data: { process } });
	} else {
		dispatch({ type: HIDE_LOADER, data: { process: [] } });
	}
};

export const changeBotWaitLoader = (botWaitLoader) => (dispatch, getState) => {
	dispatch({ type: BOT_WAIT_LOADER, data: { botWaitLoader } });
};

export const showFailedLoader = (title) => (dispatch, getState) => {
	dispatch({ type: SHOW_FAILED_LOADER, data: { failedProcess: true } });
};

export const hideFailedLoader = (title) => async (dispatch, getState) => {
	dispatch({ type: HIDE_FAILED_LOADER, data: { failedProcess: false } });
	
};